<template>
    <div>
        <Tab name="3"></Tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.channelName" placeholder="渠道名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.trackPath" placeholder="跟踪参数" size="small"></el-input>
                </el-col> -->
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.selectValue" class="input-with-select" size="small">
                        <el-select v-model="params.selectType" slot="prepend" placeholder="请选择">
                            <el-option label="按渠道" :value="1"></el-option>
                            <el-option label="按跟踪参数" :value="2"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/report/channel/channelEdit')" type="primary" icon="el-icon-plus" size="small" @click="add">新增渠道</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="channelName" label="渠道名称" min-width="100" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link :href="`/report/channel/channelReport/reportList?selectType=1&selectValue=${scope.row.channelName}`">{{scope.row.channelName}}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="trackPath" label="跟踪参数" min-width="100" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="150">
                </el-table-column>
                <el-table-column prop="createUserName" label="创建人" min-width="100" show-overflow-tooltip>
                </el-table-column>
                 <el-table-column fixed="right" label="操作" width="80">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/report/channel/channelEdit')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >管理</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <edit ref="channelEdit" @onUpdate="getDataList()"></edit>
    </div>
</template>

<script>
import Tab from "../components/tab"
import Edit from './components/Edit.vue';
const defaultParams = {
    pageNo:1,
    trackPath:"",
    channelName:"",

    selectType: 1,
    selectValue: ''
}
export default {
    components:{Tab,Edit},
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                trackPath: this.$route.query.trackPath || "",
                channelName: this.$route.query.channelName || '',

                selectType: parseInt(this.$route.query.selectType || 1),
                selectValue: this.$route.query.selectValue || "",
            },
            listLoading: true,
        }
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.params = {
                ...this.params,
                channelName: this.params.selectType == 1 ? this.params.selectValue : '',
                trackPath: this.params.selectType == 2 ? this.params.selectValue : '',
            }
            this.$request({
                url: "/report/channel/channelList",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        add(){
            this.$refs.channelEdit.show();
        },
        edit(id){
            this.$refs.channelEdit.show(id);
        }
    }
}
</script>

<style lang="scss" scoped>

</style>